import React from 'react';

export default class ProgressBar extends React.Component {
    static defaultProps = {
        height: 2,
        percent: 0,
        color: "rgb(98, 145, 192)",
        speed: .4,
        style: {}
    };
    constructor(props) {
        super(props);
        this.state = {
            percent: 0
        }
    }
    componentDidMount() {
        this.timer = setInterval(() => {
            var currentPercent = this.state.percent;
            if(currentPercent == 100) {
                this.setState({percent: 0});
            } else if(currentPercent < 100) {
                this.setState({percent: currentPercent + 5});
            }
        }, 300);
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
    }
    render() {
        var progressStyle = Object.assign({
            position: 'absolute',
            margin: '0px',
            zIndex: 1,
            background: this.props.color,
            width: `${this.state.percent}%`,
            maxWidth: '100% !important',
            height: `${this.props.height}px`,
            boxShadow: '1px 1px 1px rgba(0,0,0,0.4)',
            borderRadius: '0 1px 1px 0',
            WebkitTransition: `${this.props.speed}s width, ${this.props.speed}s background-color`,
            transition: `${this.props.speed}s width, ${this.props.speed}s background-color`
        }, this.props.style);

        return (
            <div style={{position: 'relative', top: `${this.props.top}px`, left: 0}}>
                <div className='progress' style={progressStyle}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/progress-bar/ProgressBar.js